export default "__VITE_ASSET__Dnlqwv7w__"